import { useState, useEffect, useRef } from "react";
import React from "react";
import { Link } from "react-router-dom";
import { BASE_URL, security_key, IMAGE_URL } from "../../global";
import axios from "axios";
import VideoFrame from "./../../Assets/img/video-frame.jfif";

const GlobalSearch = () => {
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [showResults, setShowResults] = useState(false);
    const [filteredResults, setFilteredResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const searchBoxRef = useRef(null);

    const fetchData = async (keyword) => {
        try {
            setLoading(true);
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "globalSearch",
                search: keyword,
            });
            const output = response.data;

            if (output.length > 0) {
                setFilteredResults(output);
                setShowResults(true);
            } else {
                setFilteredResults([]);
                // setShowResults(false);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isSearchOpen && searchBoxRef.current) {
            searchBoxRef.current.focus();
        }
    }, [isSearchOpen]);

    const toggleSearch = () => {
        setIsSearchOpen((prev) => !prev);
        if (!isSearchOpen) {
            setSearchTerm('');
            setShowResults(false);
        }
    };

    const handleClickOutside = (e) => {
        if (searchBoxRef.current && !searchBoxRef.current.contains(e.target)) {
            setIsSearchOpen(false);
            setShowResults(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
        fetchData(e.target.value);
    };

    const searchIconClass = isSearchOpen ? "fa-solid fa-xmark d-none f-14" : "fa-solid fa-magnifying-glass text-dark f-14";

    return (
        <div>
            <div className="d-flex">
                <button
                    className="btn border-0 text-dark f-14 pt-2 ps-0 pe-2 pe-md-0 pe-lg-2 "
                    onClick={toggleSearch}
                >
                    <i className="fa-solid fa-magnifying-glass text-dark f-14"></i>
                </button>
                {isSearchOpen && (
                    <button className={isSearchOpen ? "d-block btn border-0 ps-0 pt-2" : "d-none"}
                        onClick={() => {
                            setIsSearchOpen(false);
                            setShowResults(false);
                            setSearchTerm('');
                        }}>
                        <i className="fa-solid fa-xmark f-14"></i>
                    </button>
                )}
            </div>
            <div className={`search-container ${isSearchOpen ? "open" : ""} ${showResults && filteredResults.length > 0 ? "show-results" : ""}`}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12 search-toggle" ref={searchBoxRef}>
                            <form className="d-flex gap-4 search-form">
                                <input
                                    type="search"
                                    className="form-control search-input"
                                    value={searchTerm}
                                    onChange={handleInputChange}
                                    placeholder="Search for articles, tags..."
                                    onFocus={() => setShowResults(searchTerm.length > 0)}
                                />
                                <button className="btn btn-search" type="button">
                                    Search
                                </button>
                            </form>
                            {searchTerm && (
                                <div className="search-result-toggle">
                                    {loading ? (
                                        <div className="loader">
                                            <p>Loading...</p>
                                        </div>
                                    ) : filteredResults.length > 0 ? (
                                        filteredResults.map((blog) => (
                                            <div key={blog.pk_ac_key} className="result-item">
                                                {JSON.parse(blog.additionalFields)
                                                    .slice(0, 1)
                                                    .map((row) => {
                                                        if (row.base_type == "image") {
                                                            return <img src={IMAGE_URL + row.file_name} alt={blog.ac_name} width={50} height={50} />;
                                                        } else if (row.base_type == "video") {
                                                            return <img src={VideoFrame} alt={blog.ac_name} width={50} height={50} />;
                                                        }
                                                    })}
                                                <Link to={`/detail/${encodeURIComponent(blog.pk_ac_key)}`} onClick={toggleSearch}>
                                                    {blog.ac_name}
                                                </Link>
                                            </div>
                                        ))
                                    ) : (
                                        <p>No results found.</p>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>
                {`
                    /* Main search container styling */
                    .search-container {
                        position: fixed;
                        top: 70px;
                        left: 0;
                        right: 0;
                        background-color: #f8f9fa;
                        height: 0;
                        overflow: hidden;
                        z-index: 1000;
                        transition: height 0.3s ease;
                    }

                    .search-container.open {
                        height: 65px; /* Initial height */
                    }

                    .search-container.show-results {
                        height: 400px; /* Height with results displayed */
                    }

                    /* Search form styling */
                    .search-form {
                        display: flex;
                        align-items: center;
                        padding: 10px;
                    }

                    .search-input {
                        flex-grow: 1;
                        border: 1px solid #ddd;
                        padding: 10px;
                        border-radius: 0;
                    }

                    .btn-search {
                        background-color: #333;
                        color: white;
                        border: none;
                        padding: 10px 20px;
                        font-weight: bold;
                        cursor: pointer;
                    }

                    .btn-search:hover {
                        background-color: #555;
                    }

                    /* Search results styling */
                    .search-result-toggle {
                        margin-top: 10px;
                        background-color: white;
                        padding: 10px;
                        border-radius: 5px;
                        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
                        max-height: 300px;
                        overflow-y: auto;
                        position: relative;
                        z-index: 9999;
                    }

                    .result-item {
                        display: flex;
                        align-items: center;
                        padding: 10px 0;
                        border-bottom: 1px solid #eee;
                    }

                    .result-item img {
                        border-radius: 5px;
                        margin-right: 10px;
                    }

                    .result-item a {
                        font-weight: bold;
                        color: #333;
                        text-decoration: none;
                        text-align: start;
                    }

                    .result-item a:hover {
                        color: #007bff;
                    }
                `}
            </style>
        </div>
    );
};

export default GlobalSearch;



